import Api from '@/api/api'


export default {
    getAllReports() {
        return Api.get(`/api/ReportMaster/GetAllReportsForAdmin`)
    },
    getInitialData() {
        return Api.get(`/api/InitialData/GetSuperAdminInitialData`);
    },
    addReportMaster(data) {
       return Api.post(`/api/ReportMaster/AddReportMaster`, data);
    },
    getParticularReportById(reportId){
      return Api.get(`/api/ReportMaster/GetReportByIdForAdmin?reportId=${reportId}`);
    },
    getParentReportById(){
        return Api.get(`/api/ReportMaster/GetAllReportIdAndNameForAdmin`);
    },
    updateReport(editId, data) {
        return Api.put(`/api/ReportMaster/UpdateReportMaster?reportId=${editId}`, data);
    },
    deleteReport(reportId) {
        return Api.post(`/api/ReportMaster/DeleteReportMaster`,reportId)
    },
    
}